import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

function LocationsNeedsAfterHoursQuestionBubble() {
  return (
    <Tooltip
      variant="error"
      content={
        <Stack gap={2}>
          <T weight="bold">After hours needed</T>
          <T size="xs" color="secondary">
            The ability to schedule shipments with pickups or deliveries outside
            of normal business hours is only available when the{" "}
            <strong>After Hours</strong> special service is selected prior to
            quoting.
          </T>
          <T size="xs" color="secondary">
            If you need this, please go back and modify the details and request
            another quote.
          </T>
        </Stack>
      }
    />
  );
}
export default LocationsNeedsAfterHoursQuestionBubble;
